var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a8372ea1cd1c2b1a3687d316e83bdfbc702e96f6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"a8372ea1cd1c2b1a3687d316e83bdfbc702e96f6"};
      